<template>
    <el-dialog class="common-dialog noHeader register-info-dialog" title="贵公司的尊姓大名是?" :visible="isShowModal" :show-close="false">
        <div class="content">
            <group-input class="company-input" v-model="name" ref="groupInput"></group-input>
        </div>
        <el-button type="primary" size="full" @click="save()">下一步</el-button>
    </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'
import groupInput from '../../components/CompanyGroupInput'
export default {
    components: {
        groupInput
    },
    data() {
        return {
            name: ''
        }
    },
    computed: {
        ...mapState(['loginStep', 'user']),
        isShowModal() {
            return this.loginStep === 'company';
        }
    },
    methods: {
        ...mapMutations(['setLoginStep', 'setUserInfo']),
        ...mapMutations('company', ['setCompanyInfo']),
        ...mapActions('company', ['getIndustries']),
        ...mapActions('group', ['createNew']),
        async save() {
            try {
                await this.$refs['groupInput'].validate();
                let group = await this.createNew(this.name);
                this.setCompanyInfo({name: this.name});
                this.setUserInfo({companyGroupId: group._id});
                this.name = '';
                this.setLoginStep('industry');
                this.getIndustries();
            } catch (err) {
                this.$message.error(err || '创建失败，请稍后重试');
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.content {
    height: 18rem;
    padding: 1rem 1rem 0;
    border: 1px solid #e6e6e6;
}
</style>
<style lang="scss">
    .company-input {
        width: 100%;
        .el-input__inner {
            height: 60px;
            font-size: 18px;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/login/LoginCompany.vue